import React from 'react';
import {getServerTexts} from './texts';
import {predictionModuleId} from './consts';
import {AnalyticsProvider} from './AnalyticsProvider';
import {checkLicense} from '../License/services/licenses';

export async function renderAnalytics(root) {
    await getServerTexts();
    await checkLicense(predictionModuleId);
    root.render(<AnalyticsProvider />);
}
